





































import Processing from "@/components/table/Processing.vue";
import { onMounted } from "@vue/composition-api";
import Vue from "vue";
import AuditFilters from "./AuditFilters.vue";
import AuditItemRow from "./AuditItemRow.vue";
import { state } from "./data/state";
import { table_columns } from "./data/table.config";
import { AuditItem } from "./data/models";
import { UseModal } from "@/components/root/modal";
import PlaybookResultsModalVue from "./playbook-results-modal/PlaybookResultsModal.vue";

export default Vue.extend({
  components: { AuditFilters, Processing, AuditItemRow },
  setup() {
    const { is_loading, items } = state;

    const show_results = async (item: AuditItem) => {
      UseModal().show(PlaybookResultsModalVue, item);
    };

    onMounted(async () => {
      await state.init();
    });
    return {
      is_loading,
      items,
      table_columns,
      show_results,
    };
  },
});
